/**
 * @generated SignedSource<<7575a61e168d4fd5931f7e5595e93934>>
 * @relayHash 83c667f6e4eab61cc7723fc091cb0002
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83b68e9d7eb3a6372d990fbb1ea21f606ae1cf9fdb97bb2190a609d28a9954c9

import type { ConcreteRequest } from 'relay-runtime';
export type useUpdateContentPropertyBlogUpdateMutation$variables = {
  blogPostId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateContentPropertyBlogUpdateMutation$data = {
  readonly confluence: {
    readonly updateValueBlogPostProperty: {
      readonly blogPostProperty: {
        readonly id: string | null;
        readonly key: string;
        readonly value: string;
      } | null;
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null;
        } | null;
        readonly message: string | null;
      }> | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type useUpdateContentPropertyBlogUpdateMutation = {
  response: useUpdateContentPropertyBlogUpdateMutation$data;
  variables: useUpdateContentPropertyBlogUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogPostId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "blogPostId",
        "variableName": "blogPostId"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "propertyKey"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "propertyValue"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "concreteType": "ConfluenceBlogPostProperty",
  "kind": "LinkedField",
  "name": "blogPostProperty",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "message"
},
v8 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyBlogUpdateMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
            "kind": "LinkedField",
            "name": "updateValueBlogPostProperty",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyBlogUpdateMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
            "kind": "LinkedField",
            "name": "updateValueBlogPostProperty",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "83c667f6e4eab61cc7723fc091cb0002",
    "id": "83b68e9d7eb3a6372d990fbb1ea21f606ae1cf9fdb97bb2190a609d28a9954c9",
    "metadata": {},
    "name": "useUpdateContentPropertyBlogUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyBlogUpdateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{updateValueBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
  }
};
})();

(node as any).hash = "580533e46ac660d594c903425683aacb";

export default node;
